export enum VARIANTS {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}
